export default {
    name: "AGF",

    render() {
        return
    },

    data() {
        return {
            sdkInstance: null,
            config: {},
            heartBeatCount: 0,
            interval: null,

            contentObject: null,
            adObject: null,

            contentPlaying: false,
            contentPosition: 0,

            adPlaying: false,
            adPosition: 0,

            lastLoaded: null,
            currentlyLoaded: null,
            endSent: false,

            agfScriptLoaded: false,
            scriptLoaded: false,
            queue: [],

            currentPlayhead: null,
            currentAdPlayhead: null,
        }
    },

    mounted() {

        this.$l.log('AGF: mounted()')

        this.config = this.$settings.agf.config

        // let agfScript = document.createElement('script')
        // agfScript.setAttribute('src', this.$settings.agf.script)
        // agfScript.onload = this.onReady
        // document.head.appendChild(agfScript)

        this.loadAGF()

        this.init()
    },

    methods: {

        init() {
            this.$l.log('agf: init()')

            // this.setupHeartBeat()

            // this.$events.$on(['jwAdTime'],this.onAdTime)
            this.$events.$on(['jwAdPlay','jwAdStarted'],this.onAdPlaying)
            this.$events.$on(['jwAdPause','jwAdError','jwAdComplete','jwAdSkipped', 'hdAdPause','hdAdError','hdAdComplete'],this.onAdStopping)
            this.$events.$on(['jwAdComplete','jwAdSkipped','hdAdComplete'],this.onAdComplete)

            window.addEventListener("beforeUnload",this.onClosePlayer);
            window.addEventListener("pagehide",this.onClosePlayer);
        },

        loadAGF() {

            if (!this.$manager.get('agf.active')) {
                this.$l.log('AGF is NOT active, prevent loading script');
                return;
            }

            var vm = this

            if ( !this.scriptLoaded ) {

                this.$l.log('AGF loading script');
/*
                ! function(win, bundle) {
                    win[bundle] = win[bundle] || {
                        nlsQ: function(apid, instanceName, config, scriptElement, scriptsContainer, i) {
                            scriptsContainer = win.document;
                            scriptElement = scriptsContainer.createElement("script");
                            scriptElement.async = 1;

                            // TODO: checking consent here
                            if(true) {
                                scriptElement.src = ("http:" === win.location.protocol ? "http:" : "https:") + "//cdn-gl.imrworldwide.com/conf/" + apid + ".js#name=" + instanceName + "&ns=" + bundle;
                                i = scriptsContainer.getElementsByTagName("script")[0];
                                i.parentNode.insertBefore(scriptElement, i);
                            }

                            win[bundle][instanceName] = win[bundle][instanceName] || {
                                g: config || {},
                                ggPM: function(apid, config, scriptElement, scriptsContainer, i) {
                                    (win[bundle][instanceName].q = win[bundle][instanceName].q || []).push([apid, config, scriptElement, scriptsContainer, i])
                                }
                            };

                            return win[bundle][instanceName];
                        }
                    }
                }
                (window, "NOLBUNDLE");
*/
                /* NLSQUEUE build v*/
                !function(e,n){
                    function t(e){
                        return"object"==typeof e?JSON.parse(JSON.stringify(e)):e
                    }
                    e[n]=e[n]||
                        {
                            nlsQ:function(o,r,c){
                                var s=e.document,a=s.createElement("script");
                                a.async=1;

                                // TODO: checking consent here --> consent (SourcePoint Vendor ID: 5ef4ba9d744f1a148a3450f4) checked in Tracking.vue
                                vm.$manager.vendorGrant('5ef4ba9d744f1a148a3450f4').then(function (grants) {
                                    if (grants) {
                                        vm.$l.log('AGF granted by consent tool (vendorGrant)')
                                        a.src=("http:"===e.location.protocol?"http:":"https:")+"//cdn-gl.nmrodam.com/conf/"+o+".js#name="+r+"&ns="+n;
                                        var i=s.getElementsByTagName("script")[0];
                                        i.parentNode.insertBefore(a,i);
                                    } else {
                                        vm.$l.log('AGF NOT granted by consent tool (vendorGrant)')
                                    }
                                });

                                e[n][r]=e[n][r]||{g:c||{},
                                        ggPM:function(o,c,s,a,i){e[n][r].q=e[n][r].q||[];try{var l=t([o,c,s,a,i]);e[n][r].q.push(l)}catch(e){console&&console.log&&console.log("Error: Cannot register event in Nielsen SDK queue.")}},
                                        trackEvent:function(o){e[n][r].te=e[n][r].te||[];try{var c=t(o);e[n][r].te.push(c)}catch(e){console&&console.log&&console.log("Error: Cannot register event in Nielsen SDK queue.")}}};

                                return e[n][r];
                            }
                        }
                }(window,"NOLBUNDLE");

                // Created SDK Instance
                this.sdkInstance = NOLBUNDLE.nlsQ(this.$settings.agf.apid, "nlsnInstance", this.config);

                this.scriptLoaded = true
                this.$events.emit('agfScriptLoaded')
            }
            else {
                this.$warn('AGF already loaded?')
            }
        },

        sendEvent(evtName, data=null) {
            this.$l.log('AGF - sendEvent', evtName, data)

            if(this.scriptLoaded) {

                switch(evtName) {
                    // case 'stop':
                    //     this.sdkInstance.ggPM(evtName)
                    //     break;

                    default:
                        this.sdkInstance.ggPM(evtName, data)
                        break;
                }

            }
            else {
                this.queue.push({ evtName: evtName, data: data })
            }
        },

        setupContentObject() {

            this.endSent = false;

            // source: 'vipo',
            // id: evt.item.vivi_id,
            // title: evt.item.title,
            // description: evt.item.description,
            // poster: evt.item.poster,
            // format: evt.item.vifo_name,
            // //TODO: in Sekunden umrechnen
            // duration: evt.item.seconds || evt.item.duration,
            // adZone: evt.item.vpCategory,
            // collection: evt.item.vico_id,
            // collectionName: evt.item.vico_mt_titel,
            // permalink: evt.item.link,


            // "assetid": "5be5af10a2ea507ee52d1dd8|0"
            // "type": "content"
            // "program": "Unknown"
            // "title": "Unknown|5be5af10a2ea507ee52d1dd8|Preview: Zwei Mönche in der \"Löwenhöhle\"|"
            // "length": "257"
            // "subbrand": "c02"
            // "nol_c0": "p0,0"
            // "nol_c5": "p5,https://www.vox.de/cms/die-hoehle-der-loewen-2018-welche-start-ups-sind-am-13-november-dabei-4248148.html"
            // "nol_c7": "p7,5be5af10a2ea507ee52d1dd8"
            // "nol_c8": "p8,257"
            // "nol_c9": "p9,Unknown|5be5af10a2ea507ee52d1dd8|Preview: Zwei Mönche in der \"Löwenhöhle\"|"
            // "nol_c10": "p10,vox"
            // "nol_c12": "p12,Content"
            // "nol_c18": "p18,N"
            // "nol_c15": "p15,0"
            // "nol_c2": "p2,N"
            // "nol_c16": "p16,dvrsowf_ten_voxhoehleloewen"
            // "nol_ac": "content"
            // (Quelle: www.vox.de)


            var content_metadata_object = {
                // SDK
                type: 'content',
                assetid: String(this.$item.id),
                program: String(this.$item.format), //format title
                title: this.$item.format ? String(this.$item.format) + " | " + String(this.$item.title) : String(this.$item.title), //episode title
                length: String(this.$item.duration), //duration in seconds

                // VA Beacon Metadata
                // "censuscategory": "censuscategory",
                // "vidtype": "vidtype",
                // "subcategory": "subcategory",
                // "uurl":"http://nielsen.com",

                nol_c0: 'p0,0', // number of episode part (Sendungsteilenummer) - REQUIRED
                nol_c2: 'p2,Y', //web only

                // nol_c5: '', //page url

                // Mandatory Custom Properties
                nol_c7: 'p7,'+String(this.$item.id), //video id
                nol_c8: 'p8,'+String(this.$item.duration), //duration in seconds
                nol_c9: 'p9,'+String(this.$item.format), //episode title or format title if not available
                nol_c10: 'p10,rtl2player', //publisher
                nol_c18: 'p18,N', //livestream

                nol_c12: 'p12,' + String(this.$item.videoType == 'Trailer' ? 'Trailer' : 'Content'), //Trailer or Content
                // nol_c13: '', //original air time
                // nol_c14: '', //ISO 8601 timestamp
                nol_c15: 'p15,'+String(this.$item.formatId ? this.$item.formatId : '0'), //format id
                // nol_c16: '', //marketing category
                // nol_c20: '', //GfK UID

            }

            if(this.$settings.ivw.iam_data && this.$settings.ivw.iam_data.cp) {
                // nol_c16: '', //marketing category
                content_metadata_object.nol_c16 = 'p16,'+this.$settings.ivw.iam_data.cp.replace(/^(.).(.*)$/, '$1v$2')
            }

            // this.$l.log('AGF - setupContentObject', content_metadata_object)

            this.contentObject = content_metadata_object

            this.sendEvent('loadMetadata',this.contentObject);
            this.lastLoaded = 'content'

        },

        setupAdObject(adObject) {
            this.adObject = adObject

            this.sendEvent('loadMetadata',adObject);
            this.lastLoaded = 'ad';
            this.currentAdPlayhead = null;
            this.endSent = false;
        },

        sendAdStop() {
            if(this.endSent) return;
            if(!this.adPlaying) return;
            this.sendEvent('stop', Math.floor(this.adPosition))
        },

        sendContentStop() {
            if(this.endSent) return;
            this.sendEvent('stop', Math.floor(this.contentPosition))
        },

        sendEnd() {
            if(!this.endSent) {
                this.sendEvent('end', Math.floor(this.contentPosition))
                this.endSent = true;
                this.contentObject = false;
            }
        },


        /* ----------------------------------------------------------------------------------------------------------------------
        AD EVENTS
         */

        onAdPlaying(evt) {
            this.$l.log('AGF - onAdPlaying()', evt.adposition)
            this.adPlaying = true
        },

        onAdStopping(evt) {
            this.$l.log('AGF - onAdStopping()', evt.adposition)
            if(this.lastLoaded == 'ad' && this.adPlaying) {
                this.sendAdStop();
            }
            this.adPlaying = false
        },

        onAdComplete(evt) {
            this.$l.log('AGF - onAdComplete()', evt.adposition, this.adPosition)

            this.sendAdStop();

            this.currentAdPlayhead = null;
            this.adPlaying = false
            this.adPosition = 0
        },

        onClosePlayer(evt) {

            console.log('AGF: ------------------------------ closing ...');

            if(this.endSent) {
                return;
            }

            // if(this.$jwcomp && this.$jwcomp.state != 'playing' && this.$jwcomp.adState != 'playing') {
            //     // send nothing if we are not playing anything
            //     return;
            // }

            // Only inside a midroll indicate <stop> for the ad
            if(this.lastLoaded == 'ad') {
                if(this.adObject && this.adObject.type == 'midroll' && this.adPlaying) {
                    this.sendAdStop();
                }
            }

            this.sendEnd();



        },



    },

    events: {



        /*
        EVENTS
         */

        newItemData(evt) {
            this.$l.log('AGF - received newItemData event')
            this.setupContentObject()
        },

        jwAdTime(evt) {
            this.adPosition = evt.position

            if(evt.position && this.lastLoaded == 'ad') {
                let currentSecond = Math.floor(evt.position);

                if(this.currentAdPlayhead != currentSecond) {
                    this.currentAdPlayhead = currentSecond;
                    this.$l.log('AGF - AD setPlayheadPosition', currentSecond)
                    this.sendEvent('setPlayheadPosition', currentSecond);
                }
            }
        },

        hdAdTime(evt) {
            this.adPosition = evt.currentTime

            if(evt.currentTime && this.lastLoaded == 'ad') {
                let currentSecond = Math.floor(evt.currentTime);

                if(this.currentAdPlayhead != currentSecond) {
                    this.currentAdPlayhead = currentSecond;
                    this.$l.log('AGF - AD setPlayheadPosition', currentSecond)
                    this.sendEvent('setPlayheadPosition', currentSecond);
                }
            }
        },

        jwTime(evt) {
            this.contentPosition = evt.currentTime

            if(evt.currentTime && this.lastLoaded == 'content') {
                let currentSecond = Math.floor(evt.currentTime);

                if(this.currentPlayhead != currentSecond) {
                    this.currentPlayhead = currentSecond;
                    this.$l.log('AGF - CONTENT setPlayheadPosition', currentSecond)
                    this.sendEvent('setPlayheadPosition', currentSecond);
                }
            }

        },

        jwPlay() {
            if(this.lastLoaded != 'content') {
                this.setupContentObject()
            }
        },

        jwBeforePlay() {
            if(this.lastLoaded != 'content' || this.endSent) {
                this.setupContentObject()
            }
        },

        // jwPlaylistItem() {
        //     if(this.endSent) {
        //         this.setupContentObject()
        //     }
        // },

        jwPause() {
            if(this.lastLoaded == 'content') {
                this.lastLoaded = null;
                this.sendContentStop();
            }
        },

        jwIdle(evt) {
            if(this.lastLoaded == 'content' && evt.newstate == 'idle' && evt.oldstate == 'playing') {
                this.lastLoaded = null;
                this.sendContentStop();
            }
        },

        jwBuffer(evt) {
            if(evt.oldstate == 'playing' && evt.newstate == 'buffering' && evt.reason == 'stalled') {
                // evt.reason == 'stalled'
                this.lastLoaded = null;
                this.sendContentStop();
            }
        },

        jwBeforeComplete() {
            this.sendEnd();
        },

        // jwAdComplete(evt) {
        //     // TODO - send stop event
        //     this.sendAdStop();
        //     this.currentAdPlayhead = null;
        // },
        //
        // hdAdComplete(evt) {
        //     this.sendAdStop();
        //     this.currentAdPlayhead = null;
        // },

        // jwAdMeta(evt) {
        //     this.setupAdObject(evt)
        // },

        jwAdImpression(evt) {
            this.setupAdObject({
                // SDK
                type: evt.adposition + 'roll', //preroll, midlroll, postroll
                assetid: evt.id,
                program: String(this.$item.format), //format title
                title: evt.adtitle, //ad title
                length: evt.duration, //duration in seconds
                // VA Beacon Metadata
                // "censuscategory": "censuscategory",
                // "vidtype": "vidtype",
                // "subcategory": "subcategory",
                // "uurl":"http://nielsen.com",

                nol_c8:  'p8,'+evt.duration, // duration of the video file in seconds
                nol_c10: 'p10,', // publisher
                nol_c11: 'p11,'+evt.id, // AD Id
                nol_c12: 'p12,Ad', // content type (key distinction of content, advertising, and Trailer)
                nol_c17: 'p17,' + evt.adposition + 'roll' // ad placement type (placement information of advertisement)
            });
        },

        hdAdImpression(evt) {
            this.setupAdObject({
                // SDK
                type: evt.adposition, //preroll, midlroll, postroll
                assetid: evt.homadImpressionAdId,
                program: String(this.$item.format), //format title
                title: "HomadWerbung", //ad title
                length: evt.duration, //duration in seconds
                // VA Beacon Metadata
                // "censuscategory": "censuscategory",
                // "vidtype": "vidtype",
                // "subcategory": "subcategory",
                // "uurl":"http://nielsen.com",
                nol_c8:  'p8,'+evt.duration, // duration of the video file in seconds
                nol_c10: 'p10,', // publisher
                nol_c11: 'p11,'+evt.homadImpressionAdId, // AD Id
                nol_c12: 'p12,Ad', // content type (key distinction of content, advertising, and Trailer)
                nol_c17: 'p17,' + evt.adposition // ad placement type (placement information of advertisement)
            });
        },


    }
}



// WEBPACK FOOTER //
// ./src/components/tracking/agf.js